import {CSSProperties, useEffect, useState} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {THEME} from "@components/core/theme";
import {Game, IGlobalScore, IPlayerScore, IWordScore} from "@game/game";
import {connect} from "react-redux";
import {update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    content: {
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
    },
    label: {
        flexGrow: 1,
        margin: 4
    },
    noScore: {
        alignItems: "center",
        display: "flex",
        flexGrow: 1,
        justifyContent: "center",
        textAlign: "center"
    },
    scoreColumn: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1
    },
    scoreName: {
        minWidth: 100
    },
    scoreRow: {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        paddingRight: 8
    },
    scoreSet: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        height: 100,
        overflowY: "scroll",
        paddingRight: 8
    },
    subtitle: {
        fontSize: "large",
        marginBottom: 8,
        marginTop: 8
    },
    title: {
        fontSize: "x-large"
    }
};
interface IScoreTabPanel {
    game: Game
    globalScores: IGlobalScore[]
    globalLeaderboards: IWordScore[]
    playerLeaderboards: IWordScore[]
    playerTotalScore?: IPlayerScore
    playerWordScore?: IPlayerScore
    updateDialog: Update
}

function ScoresTabPanel({game, globalScores, globalLeaderboards, playerLeaderboards, playerTotalScore, playerWordScore,
                            updateDialog}: IScoreTabPanel) {
    const [average, setAverage] = useState("");
    const [total, setTotal] = useState("");
    const handleClickWord = (wordScore: IWordScore) => () => {
        const position = wordScore.regionId !== undefined && wordScore.tileId !== undefined
            ? game.size.getTilePosition({regionId: wordScore.regionId, tileId: wordScore.tileId})
            : undefined;
        updateDialog({
            update: {
                name: "definition",
                data: {
                    word: wordScore.word,
                    position: position ? {x: position.x, y: position.y} : undefined
                }
            }
        });
    };

    useEffect(() => {
        const total = playerLeaderboards.reduce((total, score) => score.score + total, 0);

        setAverage(playerLeaderboards.length ? (total / playerLeaderboards.length).toPrecision(3) : "0");
        setTotal(total.toLocaleString());
    }, [playerLeaderboards]);
    if (playerLeaderboards.length === 0) {
        return (
            <div style={styles.noScore}>
                <LocalisedTypography content={game.userPlayer?.anonymous ? "ScoresAnonymous" : "ScoresNoScore"}
                                     style={styles.title}/>
            </div>
        );
    }
    return (
        <div style={styles.content}>
            <div style={styles.scoreColumn}>
                <div style={styles.subtitle}>
                    <LocalisedTypography content={"ScoresHighestPersonal"}/>
                </div>
                <div style={styles.scoreSet}>
                    {playerLeaderboards.map((wordScore, index) =>
                        <div key={index} style={styles.scoreRow}>
                            <div onClick={handleClickWord(wordScore)} style={styles.label}>
                                <LocalisedTypography content={wordScore.word}/>
                            </div>
                            <LocalisedTypography content={wordScore.score.toString()}/>
                        </div>)
                    }
                </div>
                <div style={styles.scoreRow}>
                    <LocalisedTypography content={"ScoresAverageHighest"} style={styles.label}/>
                    <LocalisedTypography content={average}/>
                </div>
            </div>
            <div style={styles.scoreColumn}>
                <div style={styles.subtitle}>
                    <LocalisedTypography content={"ScoresHighestGlobal"}/>
                </div>
                <div style={styles.scoreSet}>
                    {globalLeaderboards.map((wordScore, index) =>
                        <div key={index} style={styles.scoreRow}>
                            <LocalisedTypography content={game.getNickname(wordScore.player)} style={styles.scoreName}/>
                            <div onClick={handleClickWord(wordScore)} style={styles.label}>
                                <LocalisedTypography content={wordScore.word}/>
                            </div>
                            <LocalisedTypography content={wordScore.score.toString()}/>
                        </div>)
                    }
{/*
                    {globalScores?.slice(0, 10).map((globalScore, index) =>
                        <div key={index} style={styles.scoreRow}>
                            <LocalisedTypography content={game.getNickname(globalScore.player)} style={styles.label}/>
                            <LocalisedTypography content={globalScore.score.toString()}/>
                        </div>)
                    }
*/}
                </div>
                {playerTotalScore &&
                    <div style={styles.scoreRow}>
                        <LocalisedTypography content={"ScoresMeanTotalScore"} style={styles.label}/>
                        <LocalisedTypography content={(playerTotalScore.sum / playerTotalScore.count)
                            .toPrecision(2).toString()}/>
                    </div>
                }
                {playerWordScore &&
                    <div style={styles.scoreRow}>
                        <LocalisedTypography content={"ScoresMeanWordScore"} style={styles.label}/>
                        <LocalisedTypography content={(playerWordScore.sum / playerWordScore.count)
                            .toPrecision(2).toString()}/>
                    </div>
                }
            </div>
        </div>
    );
}
const mapStateToProps = (store: never) => ({
});
const connected = connect(mapStateToProps, {
    updateDialog
})(ScoresTabPanel);
export {connected as ScoresTabPanel}
